import ghProfessionSelector from '@/modules/profession/components/ProfessionSelector.vue'
import ghAirwallexCard from '@/modules/airwallex/components/airwallex-card.vue'
import formMixin from '@/modules/form/mixins/form'
import jwt from '@/utils/jwt'

export default {
  components: {
    ghProfessionSelector,
    ghAirwallexCard,
    VueRecaptcha: () => import(/* webpackChunkName: "recaptcha" */ 'vue-recaptcha')
  },

  mixins: [formMixin],

  props: {
    prefill: {
      type: Object,
      default: () => {
        return {}
      }
    },

    promoId: {
      type: String
    },

    affiliateAssociationId: {
      type: String
    }
  },

  data() {
    return {
      withoutPaymentConsent: false,
    }
  },

  computed: {
    recaptchaSitekey() {
      return LaraVue.recaptcha
    },

    /**
     * This computed data is just default value.
     * When components use this mixin you should declare and override it on components level.
     *
     * @returns {string}
     */
    createPaymentIntentEndpoint() {
      return ''
    }
  },

  created() {
    const confirmationValidator = (rule, value, callback) => {
      if (value !== this.form[rule.matchField]) {
        callback(new Error())
      } else {
        callback()
      }
    }
    if (this.form.validationRules.email_confirmation) {
      this.form.validationRules.email_confirmation = [
        ...this.form.validationRules.email_confirmation,
        {validator: confirmationValidator, message: 'Emails do not match', matchField: 'email', trigger: 'blur'}
      ]
    }

    if (this.form.validationRules.password_confirmation) {
      this.form.validationRules.password_confirmation = [
        ...this.form.validationRules.password_confirmation,
        {validator: confirmationValidator, message: 'Passwords do not match', matchField: 'password', trigger: 'blur'}
      ]
    }
  },

  methods: {
    changeProfession(profession) {
      this.form.professionId = profession
    },

    attemptSubmit(formName) {
      this.form.isProcessing = true

      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.scrollToError(formName)
          this.form.isProcessing = false
          return false
        }

        this.requestRecaptchaToken()
      })
    },

    storeAuthToken(token) {
      jwt.setToken(token)
    },

    requestRecaptchaToken() {
      this.$refs.recaptcha.reset()
      this.$refs.recaptcha.execute()
    },

    async setRecaptchaToken(token) {
      this.form.recaptcha = token

      try {
        await this.afterRecaptchaTokenSet()
      } catch ({ response }) {
        const error = response.data

        if (error.message) {
          this.formFailure({
            message: error.message
          })
        } else if (error.code) {
          this.formFailure({
            message: error.code
          })
        } else {
          this.formFailure({
            message: error.code || 'charge_failed'
          })
        }
      } finally {
        this.form.isProcessing = false
      }
    },

    async afterRecaptchaTokenSet() {
      const paymentIntent = await this.createPaymentIntent()

      const payload = {
        paymentIntentId: paymentIntent.id,
        clientSecret: paymentIntent.client_secret,
        customerId: paymentIntent.customer_id,
        cardName: this.form.cardName
      }

      if (this.withoutPaymentConsent) {
        await this.$refs.airwallex.confirmPaymentIntent(payload)
      } else {
        await this.$refs.airwallex.createPaymentConsent(payload)
      }

      await this.handlePaymentIntentConfirmed(paymentIntent.id)
    },

    async createPaymentIntent() {
      if (!this.$refs.airwallex.checkCard()) {
        this.form.isProcessing = false
        return
      }

      const { data } = await axios.post(this.createPaymentIntentEndpoint, this.form.getFormData())

      return data
    },
  }
}
